<template>
  <div class="container">
    <div class="form">
     <iframe
        src="/agreement.html"
        style="width: 100%; height: 100vh; border: none;"
      ></iframe>
      <br />
      <div class="close"><el-button v-on:click="$emit('close')">关闭</el-button></div>
    </div>
    <div class="copyright">Copyright © 2018-2023 福建省福栗网络科技有限责任公司版权所有 All Rights Reserved.   <a class="btn" target="_blank" href="https://beian.miit.gov.cn/">闽ICP备2021003651号-1</a></div>
  </div>
</template>

<script>
export default {
  name: "agreement"
}
</script>
<style>
body {
  background-color: #EFF7FF;
}
</style>
<style scoped>
.container {
  background-image: url("~@/static/register-background.png");
  background-repeat: no-repeat;
  background-position: top;
  padding-top: 86px;
}
.form {
  width: 1200px;
  padding: 50px 50px;
  min-height: 756px;
  background: #FFFFFF;
  box-shadow: 0px 7px 27px 0px rgba(133, 169, 231, 0.51);
  border-radius: 20px;
  margin: 0 auto;
  text-align: left;
}
.form li{
  list-style: none;
}
.form h3 {
  text-align: center;
}
.close {
  text-align: center;
}
.copyright {
  margin-top: 121px;
  font-size: 12px;
  font-family: SimSun;
  font-weight: 400;
  color: #142C44;
  margin-bottom: 27px;
}
.btn {
  text-decoration: none;
  color: #142C44;
}
</style>